import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoading: false,
  payPlanOptions: [],
  statementPayPlanOptions: [],
  newPlan: null,
  newStatementPlan: null,
  payPlanDateToPay: '1',
  statementPayPlanDateToPay: '1',
  revision: null,
};

export const accountDetailsSlice = createSlice({
  name: 'accountDetailsSlice',
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    setLoading: (state, action) => {
      return { ...state, isLoading: action.payload };
    },
    setPayPlanOptions: (state, action) => {
      return { ...state, payPlanOptions: action.payload };
    },
    setStatementAccountPayPlanOptions: (state, action) => {
      return { ...state, statementPayPlanOptions: action.payload };
    },
    setNewPlanSchedule: (state, action) => {
      return { ...state, newPlan: action.payload };
    },
    setNewStatementPlanSchedule: (state, action) => {
      return { ...state, newStatementPlan: action.payload };
    },
    setDateToPay: (state, action) => {
      return { ...state, payPlanDateToPay: action.payload };
    },
    setStatementDateToPay: (state, action) => {
      return { ...state, statementPayPlanDateToPay: action.payload };
    },
    setRevision: (state, action) => {
      return { ...state, revision: action.payload };
    },
  },
});
export const {
  resetState,
  setLoading,
  setFundingInstruments,
  setNewPlanSchedule,
  setNewStatementPlanSchedule,
  setPayPlanOptions,
  setStatementAccountPayPlanOptions,
  setRevision,
  setDateToPay,
  setStatementDateToPay,
} = accountDetailsSlice.actions;
export default accountDetailsSlice.reducer;
